import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import RecognitionSection from "@/components/RecognitionSection";
import ThinkersMarquee from "@/components/ThinkersMarquee";
import MechanismSection from "@/components/MechanismSection";
import OrganismSection from "@/components/OrganismSection";
import EvidenceSection from "@/components/EvidenceSection";
import AliveNowSection from "@/components/AliveNowSection";
import HoldersSection from "@/components/HoldersSection";
import FindYourWayInSection from "@/components/FindYourWayInSection";
import InvitationSection from "@/components/InvitationSection";
import Footer from "@/components/Footer";
import DonationPopup from "@/components/DonationPopup";
import ListenButton from "@/components/ListenButton";
import { homeNarration } from "@/data/homeNarration";

// Lazy-load the Globe (Three.js), heaviest dependency
const GlobeSection = lazy(() => import("@/components/GlobeSection"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      {/* 1. The whole */}
      <HeroSection />
      {/* 2. Recognition */}
      <RecognitionSection />
      {/* Famous nonlinear thinkers */}
      <ThinkersMarquee />
      {/* 3. The mechanism */}
      <MechanismSection />
      {/* 4. The organism */}
      <OrganismSection />
      {/* 5. The evidence */}
      <EvidenceSection />
      {/* 6. The world */}
      <Suspense fallback={<div className="min-h-[500px] bg-background" />}>
        <GlobeSection />
      </Suspense>
      {/* 7. What is alive right now */}
      <AliveNowSection />
      {/* 8. Who holds the space */}
      <HoldersSection />
      {/* 9. Find your way in */}
      <FindYourWayInSection />
      {/* 10. One last invitation */}
      <InvitationSection />
      <Footer />
      <DonationPopup />
      <ListenButton
        label="Listen to the guided tour"
        script={homeNarration}
        className="fixed bottom-6 right-4 md:right-6 z-40 shadow-lg shadow-foreground/10"
      />
    </div>
  );
};

export default Index;
